import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import moment from 'moment';

declare var jquery: any;
declare var $: any;

@Component({
    selector: 'app-libelle-nego',
    templateUrl: './libelle-nego.component.html',
    styleUrls: ['./libelle-nego.component.css'],
    standalone: false
})
export class LibelleNegoComponent implements OnInit {

  @Input() detail;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Output() show = new EventEmitter<any>();

  selected = [];
  dataArticle = [];
  isEmpty: Boolean = true;
  renderTable: Boolean = true;
  isEdit: Boolean = false;
  isFamille2: Boolean = false;
  default = 0;
  nbdigit;
  classPresta: String = 'detailfact ';
  adresseAchat: Boolean = false;
  devise;
  pays = '';
  focusIndex = 0;
  listExutoire: any = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  typeContenant: any = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  artContenu: any = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  listChantier = [{ id: 0, libelleObjetEntite: 'Tous' }];
  listeAgence = [{ id: 0, libelleObjetEntite: 'Toutes' }];

  listLibelleNegocie = [];
  selectedRow: any = {};
  error = '';

  @ViewChild('msg') msg;
  constructor(public common: CommonService, private modalService: BsModalService) {
    this.nbdigit = this.common.local.getObject('paramSociete').nbDigitDevise;
    this.devise = this.common.local.getObject('paramSociete').devise;
    this.adresseAchat = this.common.local.getObject('paramSociete').adresseAchat;
  }

  ngOnInit() {
    this.getlistLibelleNegocie().then(data => {
      this.isEmpty = false;
    });
  }

  hide() {
    this.show.emit();
  }

  showFormEdit(row) {
    this.selectedRow = Object.assign({}, row);
    if (this.selectedRow.id && this.selectedRow.article && this.selectedRow.article.id) {
      this.checkFamilleArt(this.selectedRow.article.id);
      this.selectedRow.add = false;
    } else {
      this.selectedRow.add = true;
      this.artContenu = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
    }
    this.selectedRow.articleContenu = this.selectedRow.articleContenu || this.artContenu[0];
    this.selectedRow.typeContenant = this.selectedRow.typeContenant || this.typeContenant[0];
    this.selectedRow.chantier = this.selectedRow.chantier || this.listChantier[0];
    this.selectedRow.agence = this.selectedRow.agence || this.listeAgence[0];
    this.selectedRow.exu = this.selectedRow.exu || this.listExutoire[0];
    this.isEdit = !this.isEdit;
    if (this.isEdit) {
      this.getListeAgence();
      this.searchTypecontenant();
    }
  }

  validerFormEdit() {
    this.isEdit = !this.isEdit;
    this.saveLibelleNego();
  }

  getlistLibelleNegocie() {
    this.detail['nomclass'] = 'Client';
    const param = {
      'servlet': 'DBGetListLibelleNego',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [['DBGetListLibelleNego'], this.detail]
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      this.listLibelleNegocie = datas.data || [];
      this.listLibelleNegocie.forEach(elt => this.getLibelleContenant(elt.typeContenant));
      return datas.data;
    });
  }

  selectRow(row) {
    this.focusIndex = this.listLibelleNegocie.indexOf(row);
    this.selected = [row];
  }

  inserteLigne() {
    this.listLibelleNegocie.splice(this.focusIndex, 0, {
      id: '1', dateDebut: moment().format('DD/MM/YYYY HH:mm:ss'),
      dateFin: '31/12/9999'
    });
    const ctrl = this;
    setTimeout(function () {
      $('.article' + (ctrl.focusIndex)).focus();
    }, 600);
  }

  deleteLigne(row) {
    this.selectedRow['nomclass'] = 'LibellesNegocies';
    this.common.closeModal();
    const list = [this.selectedRow];
    const param = {
      'servlet': 'DBEffacerLibellesNegocies',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'LIST_LIBELLES': list,
        'CLEF_USER': {
          'typeParam': 'int',
          'valeur': this.common.user[0]
        }        
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (datas.data) {
        this.getlistLibelleNegocie();
      } else {
        if (datas.message) {
          this.error = datas.message;
          this.common.openModal(this.modalService, this.msg);
        }
      }
    });
  }



  searchArticle(event) {
    this.dataArticle = [];
    const param = 2;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.dataArticle = datas.data;
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  setValue(event, row?) {
    this.checkFamilleArt(event.id);
  }

  checkFamilleArt(id) {
    const param = {
      'servlet': 'DBCheckFamilleArticle',
      'module': 'Recylog',
      'type': 'objet',
      'compression': 'false',
      'data': {
        'typeParam': 'string',
        'valeur': id
      }
    };
    return this.common.post('', { param: param }).then(datas => {
      const data = datas.data;
      this.isFamille2 = data.length && data[0] === 2 ? true : false;
      if (!this.isFamille2) {
        this.artContenu = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
        if (this.selectedRow.articleContenu) {
          this.selectedRow.articleContenu = this.artContenu[0];
        }
      }

      return datas.data;
    });
  }

  searchChantier(event) {
    this.listChantier = [{ id: 0, libelleObjetEntite: 'Tous' }];
    const param = {
      'servlet': 'DBGetChantierClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {

        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        },
        'CRITERE': event || ''
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listChantier = [...this.listChantier, ...datas.data];
      }
    });
  }

  getListeAgence() {
    const param = {
      'servlet': 'DBAgenceGet',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        },
        'CRITERE': ''
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listeAgence = [...[{ id: 0, libelleObjetEntite: 'Toutes' }], ...datas.data];
      }
    });
  }

  searchArticleContenu(event) {
    this.artContenu = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
    const param = 3;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.artContenu = [...this.artContenu, ...datas.data];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  searchTypecontenant() {
    this.typeContenant = [{ id: 0, libelleObjetEntite: 'Tous' }];
    this.common.getType('listetypeContenant').forEach(elt => {
      elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? elt.cubage.cubage + ' ' : '') +
        (elt.uniteCont ? elt.uniteCont.libelle : '');
      this.typeContenant.push(elt);
    });
  }

  searchExutoire(event) {
    const param = 6;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        const l = [{ id: 0, libelleObjetEntite: 'Tous' }];
        l.push(...datas.data);
        this.listExutoire = l;
      }
    });
  }

  focus(event) {
    const input = event.target;
    const originalValue = $(input).val();
    $(input).val('');
    $(input).blur().focus().val(originalValue);
  }

  calculMontant(row) {
    if (row.qte && row.tarif) {
      row.prixHT = row.qte * row.tarif;
    } else {
      row.prixHT = 0;
    }
  }

  saveLibelleNego() {
    this.selectedRow['nomclass'] = 'LibellesNegocies';
    this.detail['nomclass'] = 'Client';
    const param = {
      'servlet': 'DBMAJLibelleNegocie',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [['DBMAJLibelleNegocie'], this.selectedRow, this.detail, this.common.user[0]]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (datas.data) {
        this.getlistLibelleNegocie();
      } else {
        if (datas.message) {
          this.error = datas.message;
          this.common.openModal(this.modalService, this.msg);
        }
      }
    });
  }

  majRetroLibelleNego() {
    this.detail['nomclass'] = 'Client';
    const param = {
      'servlet': 'DBLibelleNegoRetro',
      'module': 'Recylog',
      'type': 'objet',
      'compression': 'false',
      'data': this.detail
    };

    return this.common.post('', { param: param }).then(datas => {
      if (datas.message) {
        this.error = datas.message;
        this.common.openModal(this.modalService, this.msg);
      }
    });
  }

  getLibelleContenant(elt) {
    if (elt) {
      elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? elt.cubage.cubage + ' ' : '') +
        (elt.uniteCont ? elt.uniteCont.libelle : '');
    }
  }

}
